















































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { reduce } from 'lodash'
import { Col, DataTable } from '@/components/molecules/DataTable'
import { ReserveSpecifyBranchCode, Reserve } from '@/api'

const COLS: Col[] = [
  {
    width: 30,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'userId',
        headerText: '予約利用者番号'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'userName',
        headerText: '予約利用者'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'reserveRegistrationTime',
        headerText: '予約日'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'preferredDate',
        headerText: '受取希望日'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'reserveExpiration',
        headerText: '受取待期限日'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'reserveSpecifyBranchCodes',
        headerText: '特定館'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'reserveRegistrationBranchCode',
        headerText: '予約館'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'forwardingBranchCode',
        headerText: '回送館'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'specifyCollectionId',
        headerText: '種別'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'reserveStatus',
        headerText: '状態'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'contactMethod',
        headerText: '連絡方法'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'collectionNo',
        headerText: '資料番号'
      }
    ]
  },
  {
    width: 140,
    items: [
      {
        name: 'edit',
        align: 'center'
      }
    ]
  }
]

@Component({
  components: {
    DataTable
  }
})
export default class ReserveRankListTable extends ComponentVue {
  @PropSync('items', {
    type: Array
  })
  internalItems!: Reserve[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  editable!: boolean

  get allCols(): Col[] {
    return COLS
  }

  get cols(): Col[] {
    if (!this.editable) {
      return this.allCols.filter((item: Col) => {
        return item.items[0].name !== 'edit'
      })
    }
    return this.allCols
  }

  get editableReserve() {
    return (reserve: Reserve) => {
      return reserve.reserveStatus.code === '4'
    }
  }

  get movableUp() {
    return (targetIndex: number) =>
      this.internalItems.some(
        (item: Reserve, index: number) =>
          index < targetIndex && this.editableReserve(item)
      )
  }

  get movableDown() {
    return (targetIndex: number) =>
      this.internalItems.some(
        (item: Reserve, index: number) =>
          index > targetIndex && this.editableReserve(item)
      )
  }

  @Emit('click:user-id')
  onClickLink() {}

  onClickUp(clickIndex: number) {
    const interChangeIndex: number = this.internalItems.reduce(
      (accum: number, currentValue: Reserve, currentIndex: number) => {
        return currentIndex < clickIndex && this.editableReserve(currentValue)
          ? currentIndex
          : accum
      },
      0
    )
    const temp = this.internalItems[clickIndex]

    this.internalItems[clickIndex] = this.internalItems[interChangeIndex]
    this.internalItems[interChangeIndex] = temp

    // 要素の交換を画面側で検知しない為、参照を変えて強制的に交換後の表示を反映させる
    this.internalItems = [...this.internalItems]
  }

  onClickDown(clickIndex: number) {
    const interChangeIndex: number = this.internalItems.findIndex(
      (item: Reserve, index: number) =>
        index > clickIndex && this.editableReserve(item)
    )
    const temp = this.internalItems[clickIndex]

    this.internalItems[clickIndex] = this.internalItems[interChangeIndex]
    this.internalItems[interChangeIndex] = temp

    // 要素の交換を画面側で検知しない為、参照を変えて強制的に交換後の表示を反映させる
    this.internalItems = [...this.internalItems]
  }

  shortNameOfReserveSpecifyBranchCode(
    array: ReserveSpecifyBranchCode[]
  ): string {
    return reduce(
      array,
      (accumulator: string, currentValue: ReserveSpecifyBranchCode, index) => {
        accumulator += currentValue.branchCode.shortName
        if (index === array.length - 1) return accumulator
        return accumulator + ','
      },
      ''
    )
  }
}
